import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import {
  Button,
  Link, Table, Tbody, Td, Tr,
} from 'idsk-react-components';
import TezaurusListActions from './component/TezaurusListActions';
import routes from '../../../../routing/routes';
import './tezaurusList.scss';
import Tezaurus from '../../../../model/Tezaurus';
import TezaurusDeleteConfirmModal from './component/TezaurusDeleteConfirmModal';
import Secured from '../../../Secured';
import UserRoleEnum from '../../../../model/currentuser/UserRole';

interface Props {
  tezaurusList: Array<Tezaurus>;
  reloadTezaurusList():void;
}

const TezaurusList = ({ tezaurusList, reloadTezaurusList }: Props): ReactElement => {
  const navigate = useNavigate();

  return (tezaurusList && (
    <>
      <TezaurusListActions />
      <Table className="tezaurus-list idsk-!-width-two-thirds">
        <Tbody>
          {tezaurusList.map(tezaurus => (
            <Tr key={tezaurus.uuid}>
              <Td>
                <Link to={routes.tezaurus.admin.termin.list.withParams(tezaurus.uuid)}>{tezaurus.nazov}</Link>
              </Td>
              <Td>
                <Secured allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS]}>
                  <>
                    <Button
                      size="small"
                      buttonStyle="link"
                      onClick={() => navigate(
                        routes.tezaurus.admin.edit.withParams(tezaurus.uuid),
                      )}
                    >Upraviť
                    </Button>
                    <span className="tezaurus-list__divider">
              &emsp;|&emsp;
                    </span>
                    <TezaurusDeleteConfirmModal tezaurus={tezaurus} reloadTezaurusList={reloadTezaurusList} />
                  </>
                </Secured>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </>
  )
  );
};

export default TezaurusList;
